import React from "react";
import PropTypes from "prop-types";
import PersistedMoveGroupTypeInfo from "./PersistedMoveGroupTypeInfo";
import PersistedMoveParentInfo from "./PersistedMoveParentInfo";

const PersistedMoveInfo = ({ group, testId }) => {
  const { propertyOverrides } = group;

  if (!propertyOverrides) {
    return null;
  }

  const { directParent, groupType } = propertyOverrides || {};

  if (directParent?.previousDirectParentId) {
    return <PersistedMoveParentInfo group={group} testId={testId} />;
  }

  if (groupType) {
    return <PersistedMoveGroupTypeInfo group={group} testId={testId} />;
  }

  return null;
};

PersistedMoveInfo.propTypes = {
  group: PropTypes.object,
  testId: PropTypes.string,
};

export default React.memo(PersistedMoveInfo);
